/** Space **/

export const SPACE_XS = 4;
export const SPACE_SM = 8;
export const SPACE_MD = 12;
export const SPACE_LG = 16;
export const SPACE_XL = 20;
export const SPACE_XXL = 24;

/** Font **/

export const FONT_XS = 12;
export const FONT_SM = 14;
export const FONT_MD = 16;
export const FONT_LG = 18;
export const FONT_XL = 20;
export const FONT_XXL = 24;

/** Font Weight **/
export const FONT_WEIGHT_400 = 400;
export const FONT_WEIGHT_500 = 500;
export const FONT_WEIGHT_700 = 700;
